// extracted by mini-css-extract-plugin
export var root = "AppFooter-module--root--2bhtr";
export var columnBig = "AppFooter-module--columnBig--2A3KU";
export var columnHeader = "AppFooter-module--columnHeader--2wUYq";
export var copyrightContainer = "AppFooter-module--copyrightContainer--xC9xU";
export var startProjectSection = "AppFooter-module--startProjectSection--3W7YQ";
export var whiteButton = "AppFooter-module--whiteButton--IQIFv";
export var contactsContainer = "AppFooter-module--contactsContainer--3s2db";
export var contactsStatic = "AppFooter-module--contactsStatic--Cn0uq";